import {createRouter, createWebHistory} from 'vue-router'

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import('@/views/HomeView.vue'),
        meta: {
            title: '课立方',
            showNav: true
        }
    },
    {
        path: '/sign-in',
        name: 'sign-in',
        component: () => import('@/views/SignInView.vue'),
        meta: {
            title: '课立方 | 登录',
            showNav: false
        }
    },
    // {
    //     path: '/sign-up',
    //     name: 'sign-up',
    //     component: () => import('@/views/SignUpView.vue'),
    //     meta: {
    //         title: '课立方 | 注册',
    //         showNav: false
    //     }
    // },
    {
        path: '/picture_repo',
        name: 'picture_repo',
        component: () => import('@/views/teacher/PictureRepoView.vue'),
        meta: {
            title: '我的图库',
            showNav: true
        }
    },
    {
        path: '/upload_lesson',
        name: 'upload_lesson',
        component: () => import('@/views/teacher/UploadLessonView.vue'),
        meta: {
            title: '发布资源',
            showNav: true
        }
    },
    {
        path: '/my_upload',
        name: 'my_upload',
        component: () => import('@/views/teacher/MyUploadView.vue'),
        meta: {
            title: '我的发布',
            showNav: true
        }
    },
    {
        path: '/my_upload/show_detail/:id',
        name: 'show_detail',
        component: () => import('@/views/LessonView.vue'),
        meta: {
            title: '资源详情',
            showNav: true
        },
        alias: '/show_detail/:id',
    },
    {
        path: '/my_upload/update/:id',
        name: 'update',
        component: () => import('@/views/teacher/UpdateLessonView.vue'),
        meta: {
            title: '修改资源',
            showNav: true
        }
    },
    {
        path: '/my_lesson',
        name: 'my_lesson',
        component: () => import('@/views/student/MyLessonView.vue'),
        meta: {
            title: '专属资源',
            showNav: true
        }
    },
    {
        path: '/study_record',
        name: 'study_record',
        component: () => import('@/views/student/StudyRecordView.vue'),
        meta: {
            title: '学习记录',
            showNav: true
        }
    },
    {
        path: '/my_like',
        name: 'my_like',
        component: () => import('@/views/MyLikeView.vue'),
        meta: {
            title: '我的收藏',
            showNav: true
        }
    },
    {
        path: '/my_collection',
        name: 'my_collection',
        component: () => import('@/views/MyCollectionView.vue'),
        meta: {
            title: '我的收藏',
            showNav: true
        }
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        component: () => import('@/views/NotFoundView.vue'),
        meta: {
            title: '404 | 课立方',
            showNav: false
        }
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    window.document.title = to.meta.title
    next()
})

export default router
